import { EEnterpriseRole, type IUserProfile } from '@/service/auth/types';

/**
 * 是否为企业管理员。
 */
export const isEnterpriseAdmin = (profile: IUserProfile) => profile.enterprise?.memberRole === EEnterpriseRole.Admin;
